import { abyssColors, primary } from '@/theme/colors';
import { Box, Skeleton, Stack, styled as muiStyled } from '@mui/material';

export const Container = muiStyled(Box)(() => ({
  width: '100%',
  height: '100%',
  overflow: 'auto',
  scrollSnapType: 'x proximity',
  marginTop: '2.4rem',
  '&::-webkit-scrollbar': {
    height: '1.4rem',
  },
  '&::-webkit-scrollbar-track': {
    background: abyssColors.primary[100],
  },
  '&::-webkit-scrollbar-thumb': {
    background: abyssColors.primary[200],
    borderRadius: '1rem',
    height: '0.6rem',
    border: `0.4rem solid ${abyssColors.primary[100]}`,
    cursor: 'grabbing',
  },
}));

export const StageList = muiStyled(Stack)(() => ({
  width: 'fit-content',
  height: '100%',
  minHeight: '300px',
  alignItems: 'flex-start',
  flexDirection: 'row',
  gap: '4.2rem',
  paddingBottom: '1.6rem',
}));

export const StageSkeleton = muiStyled(Skeleton)(() => ({
  background: primary.TintedBlue,
  transform: 'unset',
  height: '60rem',
  borderRadius: '0.8rem',
}));
